/** Hands the browser a file to save. The one DOM side effect of this feature. */
export function downloadFile(fileName: string, content: string, type: string): void {
    const url = URL.createObjectURL(new Blob([content], { type }));
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(url);
}

export function downloadJson(fileName: string, content: string): void {
    downloadFile(fileName, content, 'application/json');
}

/** The UTF-8 byte-order mark, written as an escape: the character itself is invisible. */
const BOM = '\uFEFF';

/** With a BOM, so a spreadsheet opens accented client names as UTF-8. */
export function downloadCsv(fileName: string, content: string): void {
    downloadFile(fileName, `${BOM}${content}`, 'text/csv;charset=utf-8');
}
